import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pretty",
  "description": "",
  "published": "2006-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/pretty/swizec/364"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday a lot of time has gone into trying to get Xgl to work. It is a graphics server for linux that enables you to have some pretty spiffy looking things going on when you're using the computer much like you can in Mac OS X and Aero in Vista. Yes, it is very resource hungry but I really just wanted to give it a go and maybe perhaps if it doesn't kill the computator too much to use it constantly.`}</p>
    <p>{`Alas it has turned out that I didn't manage to get it working and the one time I did log in and almost managed to work with it the computer was `}<em parentName="p">{`so`}</em>{` slow it was useless. Like trying to run Win98 on a IBM 486, or perhaps worse. The flaw got blamed on the slow motherboard and CPU and the correct configurations were put back to work with regular 2D Xorg.`}</p>
    <p>{`I spoke to the editor of `}<a parentName="p" {...{
        "href": "http://www.locutio.si/"
      }}>{`Locutio`}</a>{`, which is an online literature magazine that seems to have been around for quite a while, and I have to say I like how the website looks. He agreed to publish a story of mine or an excerpt of it, which is great, but what was really awesome was the extensive and very constructive criticism of my writing which will help me grow as a writer and really inhance my style. It's things like these that really mean a lot to a beginer.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      